import { useRef } from 'react';
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import { Download } from 'lucide-react';

import { SoftCard } from '@/components/ui/soft-card';
import { analytics } from '@/lib/analytics';

const DOWNLOAD_SIZE_PX = 1024;

function triggerDownload(dataUrl, filename) {
	const anchor = document.createElement('a');
	anchor.href = dataUrl;
	anchor.download = filename;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
}

export function QRCodeCard({ url, shopSlug, shopId, organisationId }) {
	const hiddenCanvasWrapperRef = useRef(null);

	if (!url) return null;

	const handleDownload = () => {
		const canvas = hiddenCanvasWrapperRef.current?.querySelector('canvas');
		if (!canvas) return;

		triggerDownload(canvas.toDataURL('image/png'), `QR-${shopSlug || 'storefront'}.png`);

		if (shopId || organisationId) {
			analytics.track('qr-code-downloaded', { shopId, organisationId, url }).catch(() => {});
		}
	};

	return (
		<SoftCard className="space-y-4 !p-5 md:!p-6">
			<div>
				<h3 className="text-[15px] font-bold text-foreground md:text-base">QR code for your shop window</h3>
				<p className="mt-0.5 text-xs text-muted-foreground">
					Download and print it — shoppers who scan it land on your Local Storefront.
				</p>
			</div>

			<div className="flex justify-center rounded-2xl border border-border bg-card p-4">
				<QRCodeSVG value={url} size={160} level="M" />
			</div>

			<p className="break-all text-center text-xs text-muted-foreground">{url}</p>

			<button
				type="button"
				onClick={handleDownload}
				className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-foreground px-4 py-2.5 text-sm font-semibold text-background transition hover:opacity-90"
			>
				<Download className="h-3.5 w-3.5" /> Download QR code
			</button>

			<div
				ref={hiddenCanvasWrapperRef}
				aria-hidden="true"
				className="pointer-events-none absolute -left-[9999px] top-0 h-0 w-0 overflow-hidden"
			>
				<QRCodeCanvas value={url} size={DOWNLOAD_SIZE_PX} level="M" />
			</div>
		</SoftCard>
	);
}
